<template>
  <b-container>
    <b-row style="margin-top:25px">
      <b-card-group deck v-loading="loading">
        <b-card header="Firma Ödeme Ayarları" header-tag="header">
            <div style="margin-bottom:10px">
              <b-button size="sm" id="show-btn" @click="$bvModal.show('newModal')">Yeni Ekle</b-button>

              <b-modal id="newModal" hide-footer>
                <template #modal-title>
                  Yeni Ödeme Sistemi Ekle
                </template>
                <div class="d-block text-center">
                  <b-row>
                      <b-col cols="12">
                            <b-form-select v-model="new_payment" class="form-control mb-3">
                              <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                              <b-form-select-option :value="item.id" v-for="(item,key) in all_payments" :key="key">{{ item.name }}</b-form-select-option>
                            </b-form-select>
                      </b-col>
                  </b-row>
                </div>
                <b-button class="mt-3" style="margin-right:10px" block @click="$bvModal.hide('newModal')">Kapat</b-button>
                <b-button class="mt-3" variant="success" block @click="setNew()">Ekle</b-button>
              </b-modal>
            </div>
            <b-row>
              <b-col cols="4">
                <b-list-group>
                  <b-list-group-item style="cursor:pointer" v-for="(item,key) in payments" :key="key" @click="setActivePayment(item)">
                    <b style="font-size:14px">{{ item.payment.name }} </b>
                    <span style="font-size:14px; float:right" :class="item.is_active == 1 ? 'text-success' : 'text-danger'">{{ item.is_active == 1 ? 'Aktif' : 'Pasif'}}</span>
                  </b-list-group-item>
                </b-list-group>
              </b-col>
              <b-col cols="8" v-if="!_.isEmpty(activePayment)">
                  <b-card :header="activePayment.payment.name" header-tag="header">
                      <b-row>
                        <b-col cols="12">
                            <b-row>
                              <b-col cols="3">
                                <b-form-select size="sm" @change="changeStatus($event, activePayment.client_id, activePayment.id)" v-model="activePayment.is_active" class="form-control mb-3 form-control-sm"  placeholder="Ödeme Notunuz">
                                  <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                                  <b-form-select-option :value="1">Aktif</b-form-select-option>
                                  <b-form-select-option :value="0">Pasif</b-form-select-option>
                                </b-form-select>
                              </b-col>
                              <b-col cols="3">
                                <b-form-select size="sm" v-model="form.mode" class="form-control mb-3 form-control-sm">
                                  <b-form-select-option disabled :value="null">Mod Seçiniz</b-form-select-option>
                                  <b-form-select-option value="staging">Test Modu</b-form-select-option>
                                  <b-form-select-option value="production">Gerçek Mod</b-form-select-option>
                                </b-form-select>
                              </b-col>
                              <b-col cols="4">
                                  <b-form-input size="sm" placeholder="Taksit sayısını giriniz (2,4,5,7)" v-model="form.installments"></b-form-input>
                              </b-col>
                              <b-col cols="2">
                                  <el-popconfirm
                                    confirm-button-text='Evet'
                                    cancel-button-text='Hayır'
                                    variant="danger"
                                    size="sm"
                                    icon="el-icon-info"
                                    icon-color="red"
                                    @onConfirm="remove(activePayment.client_id, activePayment.id)"
                                    title="Silmek istediğine emin misin ?"
                                  >
                                    <el-button slot="reference" size="small" type="danger">Sil</el-button>
                                  </el-popconfirm>
                              </b-col>
                            </b-row>
                        </b-col>
                        <b-col cols="6">
                          <h6>Staging</h6>
                          <div v-for="(item,key) in form.staging" :key="key">
                            <b-form-group :label="item.key">
                                <b-form-input size="sm" :placeholder="item.key" v-model="item.value"></b-form-input>
                            </b-form-group>
                          </div>
                        </b-col>
                        <b-col cols="6">
                          <h6>Production</h6>
                          <div v-for="(item,key) in form.production" :key="key">
                            <b-form-group :label="item.key">
                                <b-form-input size="sm" :placeholder="item.key" v-model="item.value"></b-form-input>
                            </b-form-group>
                          </div>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group style="margin-top:10px">
                              <b-button @click="send(activePayment.client_id, activePayment.id)" variant="primary" size="sm">Güncelle</b-button>
                            </b-form-group>
                        </b-col>
                      </b-row>
                  </b-card>
              </b-col>
            </b-row>
        </b-card>
      </b-card-group>
    </b-row>
  </b-container>
</template>

<script>
  export default{
    name: 'CompaniesPayment',
    data(){
      return{
        id: this.$route.params.id,
        step: 1,
        loading: false,
        new_payment: null,
        payments:[],
        all_payments: [],
        activePayment: {},
        form: {
          mode: null,
          staging : [],
          production : [],
        },
      }
    },
    created(){
      this.fetchAllPayments();
      this.fetchPayments();
    },
    methods:{
      setActivePayment(item){
        this.activePayment = item;
        if(_.isEmpty(this.activePayment.config) || _.isNull(this.activePayment.config)){
          this.form.staging = []
          this.form.mode = this.activePayment.mode;
          this.form.installments = this.activePayment.config.installments;
          this.form.production = []
          _.forEach(this.activePayment.payment.parameters,((value,key) => {
              this.form.staging.push({ key: value, value: null});
              this.form.production.push({ key: value, value: null});
          }));
        }else{
          this.form.installments = _.join(this.activePayment.config.installments, ',');
          this.form.mode = this.activePayment.mode;
          this.form.production = this.activePayment.config.production;
          this.form.staging = this.activePayment.config.staging;
        }
      },
      setNew(){
        this.loading = true;
        axios.post('/client/' + this.$route.params.id + '/payments/create', { id : this.new_payment })
        .then((response) => {
            this.$store.dispatch('alert/message', { type: 'success', title: 'Ekleme Başarılı'});
            this.$bvModal.hide('newModal');
            this.fetchPayments();
            this.new_payment = null;
        })
        .catch((err) => {
        })
        .finally(()=>{
            this.loading = false;
        })
      },
      remove(id, paymentId){
        this.loading = true;
        axios.delete('/client/' + id + '/payments/' + paymentId + '/delete')
        .then((response) => {
            this.$store.dispatch('alert/message', { type: 'success', title: 'Güncelleme Başarılı'});
            this.fetchPayments();
            this.activePayment = {};
        })
        .catch((err) => {
        })
        .finally(()=>{
            this.loading = false;
        })
      },
      changeStatus(event, id, paymentId){
        this.loading = true;
        axios.put('/client/' + id + '/payments/' + paymentId + '/status', { status: event })
        .then((response) => {
            this.$store.dispatch('alert/message', { type: 'success', title: 'Güncelleme Başarılı'});
        })
        .catch((err) => {
        })
        .finally(()=>{
            this.loading = false;
        })
      },
      send(id, paymentId){
        this.loading = true;
        axios.post('/client/' + id + '/payments/' + paymentId + '/update', this.form)
        .then((response) => {
            this.$store.dispatch('alert/message', { type: 'success', title: 'Güncelleme Başarılı'});
            this.$router.push({name: 'Companies'});
        })
        .catch((err) => {
        })
        .finally(()=>{
            this.loading = false;
        })
      },
      fetchAllPayments(){
        axios.get('/list/payments')
        .then((response) => {
            this.all_payments = response.data.data;
        })
        .catch((err) => {
        })
        .finally(()=>{
        });
      },
      fetchPayments(){
        this.loading = true;
        axios.get('/client/' + this.id + '/payments')
        .then((response) => {
            this.payments = response.data.data;
        })
        .catch((err) => {
        })
        .finally(()=>{
          this.loading = false;
        });
      },
    }
  }
</script>